module.exports = __webpack_public_path__ + "img/web.a0ce1192.png";